<template>
  <!-- 友邦登录 -->
  <aia-container>
    <div slot="login" class="aia-box">
      <div v-if="isTest">ID: {{ third_platform_id }}</div>
      <div class="aia-button-login">
        <el-button
          @click="handleNormalUserLogin"
          class="button-custom aia-button aia-button-custom"
        >
          进入游元会
        </el-button>
      </div>
      <!-- <div class="aia-button-next">
        <div class="aia-button-agent">
          <span @click="handleAgentUserLogin">代理人登录</span>
        </div>
      </div> -->
      <AiaAgreement v-model="form.agreement1" />
      <AiaAgreementCustom v-model="form.agreement2" />
    </div>
  </aia-container>
</template>

<script>
import AiaAgreement from './components/AiaAgreement'
import AiaAgreementCustom from './components/AiaAgreementCustom'
import AiaContainer from './components/AiaContainer'
import { isWechat } from '@/utils/index'
import { param2Obj, deleteUrlParam } from '@/utils/utils'
import { saveLoginInfo } from '@/utils'
import { handleLogin } from '@/utils/mutiple.js'
import { setItem, getItem } from '@/utils/storage-main.js'
import { getBusinessType } from '@/constant'
import _throttle from 'lodash/throttle'

const AiaConfig = getBusinessType()
const AIA_ID = AiaConfig.id
const userRoleMap = {
  login: false,
  register: true,
}

export default {
  data() {
    return {
      form: { agreement1: false, agreement2: false },
      third_platform_id: '',
      isAgent: false,
      isNewUser: false,
      redirectUrl: '',
    }
  },
  components: { AiaAgreement, AiaAgreementCustom, AiaContainer },
  created() {
    this.init()
  },
  async mounted() {
    const isCanLogin = this.isWX() && this.isFromAia()

    if (isCanLogin) {
      await this.login()
      this.getUserExtraInfo()
    }
  },
  computed: {
    isTest() {
      return this.$route.query.aia_test
    },
  },
  methods: {
    init() {
      // const customerId = this._getCustomerId()

      this.handleShareInfo()
      this.handleUrlCustomerId()
      this.handleCheckLoginEnv()
    },
    _urlParamsMap() {
      const { redirect_url } = this.$route.query
      const redirectUrlObj = param2Obj(redirect_url)
      const paramsMap = { ...this.$route.query, ...redirectUrlObj }

      return paramsMap
    },
    _getCustomerId() {
      const { customerId } = this._urlParamsMap()

      return customerId || getItem('aiaCustomerId')
    },
    handleShareInfo() {
      // source=aia&share_id=1234s&extra_conf=AGENT_00
      let extraParams = ''
      const shareMap = this._urlParamsMap()

      const ignoreParams = [
        'customerId',
        'hide',
        'lang',
        'name',
        'redirect_url',
        'enter',
      ]

      for (const key in shareMap) {
        const value = shareMap[key]
        const isExtraParams =
          !ignoreParams.includes(key) && value && !extraParams?.includes(key)

        if (isExtraParams) {
          extraParams = `${extraParams}&${key}=${value}`
        }
      }
      setItem('extraParams', extraParams)
    },
    handleUrlCustomerId() {
      let new_redirect_url = ''
      const url = decodeURIComponent(window.location.href)
      const { customerId, redirect_url } = this._urlParamsMap()

      customerId && setItem('aiaCustomerId', customerId)

      let temp_url = deleteUrlParam(url, ['redirect_url', 'customerId'])

      if (redirect_url) {
        const urlArr = redirect_url?.split('?') || []

        if (urlArr?.length) {
          new_redirect_url = urlArr[0]
          this.redirectUrl = new_redirect_url
        }

        const redirectUrlObj = param2Obj(redirect_url)

        for (const key in redirectUrlObj) {
          if (
            key != 'customerId' &&
            redirectUrlObj[key] &&
            !temp_url.includes(key)
          ) {
            temp_url = `${temp_url}&${key}=${redirectUrlObj[key]}`
          }
        }
      }
      const new_url = `${temp_url}&redirect_url=${new_redirect_url}`

      window.history.replaceState({}, '', new_url)
    },
    // 检测是否具备 aia 登录条件, 不具备则跳转友邦
    handleCheckLoginEnv() {
      const customerId = this._getCustomerId()

      if (!customerId && this.redirectUrl) {
        let aiaUrl = `${process.env.VUE_APP_AIA}${this.redirectUrl}`
        const extraParams = getItem('extraParams')

        if (extraParams) {
          aiaUrl = `${aiaUrl}?${extraParams.slice(1)}`
        }

        window.location.replace(aiaUrl)
      }
    },
    // 获取
    async getUserExtraInfo() {
      const res = await this.$store.dispatch('getUserExtraInfo', {
        source: AIA_ID,
      })
      const { prop } = res?.data || {}

      if (prop?.aia_agent_code) {
        this.isAgent = true
      }
    },
    async login() {
      const res = await this.$store.dispatch('ThirdLogin', {
        source: AIA_ID,
        third_platform_id: this.third_platform_id,
      })
      const { token, expires_in, refresh_token, sso_resp, action } =
        res?.data || {}

      saveLoginInfo({ token, expires_in, refresh_token, sso_resp })

      this.isNewUser = userRoleMap[action] || false

      // 如果是登录过的用户, 在不是 退出登录 || 初次登录 的情况, 则全部自动跳转
      if (!this.isNewUser) {
        handleLogin(AIA_ID)
      }
    },
    handleNormalUserLogin: _throttle(
      function () {
        // 普通用户登录需要验证此用户是否为代理用户
        if (!this.isCommonPass() || this.isAgentUser()) return
        this.$gotinTrack.standaloneSendData({ name: `login.userlogin` })
        setItem('aiaLogined', true)
        // 登录后的跳转
        handleLogin(AIA_ID)
      },
      500,
      { trailing: false }
    ),
    handleAgentUserLogin: _throttle(
      function () {
        if (!this.isCommonPass()) return

        this.$gotinTrack.standaloneSendData({ name: `login.agentlogin` })

        if (this.isAgent) {
          setItem('aiaLogined', true)
          handleLogin(AIA_ID)
        } else {
          this.jumpToAiaAgentPage()
        }
      },
      500,
      { trailing: false }
    ),
    jumpToAiaAgentPage() {
      const query = { ...this.$route.query }

      delete query.customerId

      this.$router.replace({
        path: '/aia-hr-agent',
        query,
      })
    },
    isCommonPass() {
      if (!this.isWX() || !this.isFromAia()) return false

      if (!this.form.agreement1 || !this.form.agreement2) {
        this.$message.error('请勾选协议')
        return false
      }

      return true
    },
    isAgentUser() {
      const isAgent = this.isAgent

      if (isAgent) {
        this.$message.error(
          '识别到您当前账号已是代理人身份，请选择以代理人身份登录'
        )
        return true
      }

      return false
    },
    isWX() {
      if (!isWechat()) {
        this.$message.error('请通过微信环境体验友邦线上空间')
        return false
      }

      return true
    },
    isFromAia() {
      const customerId = this._getCustomerId()

      // guid 不曾在, 则说明不是从友邦公众号授权登录的用户, 则需要强制进入友邦链接登录
      if (!customerId) return false

      this.third_platform_id = customerId

      return true
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     if (from?.name == 'aia-agent') {
  //       vm.form.agreement = true
  //     }
  //   })
  // },
}
</script>

<style lang="scss">
// 解决ios element select点击两次才能选中的问题
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
<style lang="scss" scoped>
.aia-box {
  margin-top: 20vh;
  width: 90vw;
  .aia-button-next {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .aia-button-login {
    margin: 30px 0 60px 0;
  }
  .aia-button-agent {
    text-align: center;
    color: rgba(61, 77, 104, 0.6);
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    background: rgba(255, 255, 255, 0.3);
    width: 65px;
    height: 28px;
    line-height: 28px;
    border-radius: 28px 0 0 28px;
    padding-left: 10px;
  }
}
</style>
